import api from './api';

const permissionService = {
  // Get Catalog of modules, screens, and actions
  async getCatalog() {
    const res = await api.get('/permissions/catalog');
    return res.data;
  },

  // Get Role Permissions Matrix
  async getRolePermissions(roleId) {
    const res = await api.get(`/permissions/roles/${roleId}`);
    return res.data;
  },

  // Save Role Permissions Matrix
  async saveRolePermissions(roleId, permissions) {
    const res = await api.put(`/permissions/roles/${roleId}`, { permissions });
    return res.data;
  },

  // Get Summary Stats for Dashboard / Header Cards
  async getSummaryStats() {
    const res = await api.get('/permissions/summary-stats');
    return res.data;
  },

  // Get Audit Trail
  async getAuditTrail(params = {}) {
    const res = await api.get('/permissions/audit-trail', { params });
    return res.data;
  },

  // Get User Permission Overrides
  async getUserOverrides(employeeId, centreId = 0) {
    const params = centreId ? { centreId } : {};
    const res = await api.get(`/permissions/users/${employeeId}/overrides`, { params });
    return res.data;
  },

  // Save User Permission Overrides
  async saveUserOverrides(employeeId, overrides, centreId = 0) {
    const res = await api.put(`/permissions/users/${employeeId}/overrides`, { overrides, centreId });
    return res.data;
  },

  // Get Computed Effective Permissions
  async getEffectivePermissions(employeeId, roleId, centreId = null) {
    const params = { employeeId, roleId };
    if (centreId) params.centreId = centreId;
    const res = await api.get('/permissions/effective', { params });
    return res.data;
  },

  // Get Workspaces for an Employee
  async getUserWorkspaces(employeeId) {
    const res = await api.get(`/permissions/user-workspaces/${employeeId}`);
    return res.data;
  },

  // Save Workspaces for an Employee
  async saveUserWorkspaces(employeeId, workspaces) {
    const res = await api.post(`/permissions/user-workspaces/${employeeId}`, { workspaces });
    return res.data;
  },

  // Select workspace after login
  async selectWorkspace(centreId, roleId) {
    const res = await api.post('/auth/select-workspace', { centreId, roleId });
    return res.data;
  },

  // Switch workspace at runtime
  async switchWorkspace(centreId, roleId) {
    const res = await api.post('/auth/switch-workspace', { centreId, roleId });
    return res.data;
  },

  // Get Workspaces for a username before login
  async getWorkspacesByUsername(username) {
    const res = await api.get('/auth/user-workspaces', { params: { username } });
    return res.data;
  },

  // Create new role
  async createRole(roleName, description = '') {
    const res = await api.post('/permissions/roles', { roleName, description });
    return res.data;
  }
};

export default permissionService;

